import type { GuidanceLevel } from '@itin/shared'
import { createContext, use, type ReactNode } from 'react'

/**
 * How much the product explains itself.
 *
 * Ana is learning a tool that replaces one she knew. Most fields here are
 * obvious to whoever specified them and not to whoever fills them in, and the
 * gap is invisible from the inside: nobody who designed a field called
 * "Confirmation number" wonders whether it will be shown to the traveller, sent
 * to anyone, or used to look anything up.
 *
 * So every field can say what it is for and what the product will do with what
 * is typed there. That is deliberately more explanation than a finished product
 * should carry, which is why it is a setting and not a design: the sentences are
 * scaffolding, and scaffolding that cannot be taken down is just clutter with a
 * good excuse. `full` now, `brief` once she stops reading them, `off` once
 * nobody asks — and then the `*.guidance` keys come out of both catalogues in
 * one deletion.
 */
const GuidanceContext = createContext<GuidanceLevel>('full')

export function GuidanceProvider({
  level,
  children,
}: {
  level: GuidanceLevel
  children: ReactNode
}) {
  return <GuidanceContext value={level}>{children}</GuidanceContext>
}

export function useGuidanceLevel(): GuidanceLevel {
  return use(GuidanceContext)
}
